import React from 'react';

import { cx } from '@travel/utils';

import iconStyles from '@travel/icons/svgIcon.module.scss';
import styles from './likeButton.module.scss';

import type { Props as IconProps } from '@travel/icons/withIconProps';

export type LikeIconStyle = 'default' | 'gold';

type Props = {
  isLiked: boolean;
  iconStyle?: LikeIconStyle;
} & IconProps;

function LikeIcon(props: Props) {
  const { className, isLiked, size, iconStyle, ...rest } = props;

  const isGold = iconStyle === 'gold';
  const styledClassName = isLiked
    ? styles[`liked${isGold ? 'Gold' : ''}`]
    : styles[`unLiked${isGold ? 'Gold' : ''}`];

  return (
    <svg
      {...rest}
      className={cx(iconStyles.svgIcon, className, styledClassName)}
      width={size}
      height={size}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="likeIcon-wrapper"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M27.504 7.778c-1.898-2.482-4.22-2.8-5.837-2.633-2.292.24-4.424 1.583-5.667 3.047-1.243-1.464-3.375-2.808-5.667-3.047-1.61-.167-3.938.151-5.837 2.633-1.239 1.62-1.704 3.47-1.38 5.496.97 6.102 8.998 12.208 12.405 14.55a1 1 0 001.133 0C20.01 25.516 27.921 19.486 28.9 13.34c.326-2.052-.143-3.923-1.396-5.562" />
      </g>
    </svg>
  );
}

export default LikeIcon;
